import React, { Component } from "react";
import moment from "moment";
import { Container } from "react-bootstrap-v5";
import logo_dark from "./logo_dark4.png";
import world2doortext from "./world2doortext3.png";
// import helperFunction from "./helperFunction";
// const outerContainer = {
//   width: "1600px",
//   fontSize: "11px",
// };
// const headRow = {
//   width: "1600px",
//   fontSize: "11px",
// };
// const col50 = {
//   width: "680px",
//   fontSize: "11px",
// };
// const fontSize = {
//   fontSize: "11px",
// };

export class DownloadPayInvoice extends Component {
  formatDate = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());
    return `${day}-${month}-${year}`;
  };
  render() {
    const { data, receiptIndex } = this.props;
    const receiptObj = receiptIndex===null ? { created_date : data.dateAt ,amount : data.paid  } : data?.receipts[receiptIndex] 

    let numToWordsDhiram = (n) => {
      if (n < 0) return false;

      let single_digit = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ];
      let double_digit = [
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      let below_hundred = [
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      if (n === 0) return "Zero";

      function translate(n) {
        let word = "";
        if (n < 10) {
          word = single_digit[n] + " ";
        } else if (n < 20) {
          word = double_digit[n - 10] + " ";
        } else if (n < 100) {
          let rem = translate(n % 10);
          word = below_hundred[(n - (n % 10)) / 10 - 2] + " " + rem;
        } else if (n < 1000) {
          word =
            single_digit[Math.trunc(n / 100)] +
            " Hundred " +
            translate(n % 100);
        } else if (n < 1000000) {
          word =
            translate(parseInt(n / 1000)).trim() +
            " Thousand " +
            translate(n % 1000);
        } else if (n < 1000000000) {
          word =
            translate(parseInt(n / 1000000)).trim() +
            " Million " +
            translate(n % 1000000);
        } else {
          word =
            translate(parseInt(n / 1000000000)).trim() +
            " Billion " +
            translate(n % 1000000000);
        }
        return word;
      }

      let result = translate(n);
      return result.trim().toUpperCase();
    };
    
    return (
      <Container>
        <table
          style={{
            position: "relative",
            right: "30px",
            width: "1000px",
            maxWidth: "800px",
            margin: "0px auto 0px",
            backgroundColor: "#fff",
            padding: "15px 20px",
            WebkitBorderRadius: "3px",
            MozBorderRadius: "3px",
            borderRadius: "3px",
            WebkitBoxShadow:
              "0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)",
            MozBoxShadow: "0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)",
            letterSpacing: "0.05px",
            fontFamily: "system-ui",
            boxShadow: "0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)",
            borderTop: "solid 10px green",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th style={{ textAlign: "left" }} colSpan={9}>
                <div
                  className="top-bar"
                  style={{
                    display: "flex",
                    gap: "165px",
                    alignItems: "center",
                  }}
                >
                  <div className="top-image p-2">
                    <img
                      src={logo_dark}
                      style={{ maxWidth: "120px" }}
                      alt="logo"
                    />
                  </div>
                  <div className="top-content">
                    <p>
                      <img
                        src={world2doortext}
                        alt="image"
                        style={{
                          width: "430px",
                          height: "40px",
                          marginLeft: "-45px",
                        }}
                      />
                    </p>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                colSpan={9}
                style={{ border: "1px solid #000000", padding: "0" }}
              >
                <table
                  cellPadding={0}
                  cellSpacing={0}
                  style={{
                    width: "100%",
                    paddingTop: "0",
                    borderCollapse: "collapse",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          padding: "0 15px",
                          WebkitTextAlign: "center",
                          textAlign: "center",
                          backgroundColor: "#a1bfa1",
                          borderBottom: "1px solid #333",
                          borderRight: "1px solid #333",
                        }}
                        colSpan={2}
                      >
                        <h1
                          style={{
                            color: "#1e1e2d",
                            fontWeight: "700",
                            margin: "0",
                            fontSize: "18px",
                            fontFamily: "sans-serif",
                            padding: "14px",
                          }}
                        >
                          Payment Receipt
                        </h1>
                      </td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                      <td className="p-1">
                        <p style={{ lineHeight: 1.8 }} className="mt-2">
                          508, Dusseldorf Business Point Bldg, Al Barsha 1{" "}
                          <br />
                          Dubai, DUBAI 454487 ARE <br />
                          Kenneth.dsouza@world2door.com
                        </p>
                        <div
                          className="d-flex mb-2 mt-4"
                          style={{ lineHeight: 1.8 }}
                        >
                          <div className="col-sm-8">
                            <p className="mb-0">BILL TO</p>
                            <h6
                              className="fw-bold mb-0"
                              style={{ color: "black" }}
                            >
                              {data?.user?.user_full_name || "-"}
                            </h6>
                            <p className="mb-0">{data?.user?.user_email}</p>
                          </div>
                          <div className="col-sm-4">
                            <div className="d-flex justify-content-end">
                              <div>Date: </div>
                              <div>{this.formatDate()}</div>
                            </div>
                            <div className="d-flex justify-content-end">
                              <div>Job No. : </div>
                              <div>{data?.job_token}</div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td
                colSpan={9}
                style={{ border: "1px solid #333", padding: "0" }}
              >
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ width: "100%", textAlign: "center" }}>
                      <th
                        className="invoice-table-th-pdf"
                        // style={{
                        //   WebkitTextAlign: "left",
                        //   textAlign: "left",
                        // }}
                      >
                        SR
                      </th>
                      <th
                        className="invoice-table-th-pdf"
                        style={{ fontFamily: "system-ui" }}
                      >
                        Invoice Number
                      </th>
                      <th
                        className="invoice-table-th-pdf"
                        style={{ fontFamily: "system-ui" }}
                      >
                        Invoice Date
                      </th>
                      <th
                        className="invoice-table-th-pdf"
                        style={{ fontFamily: "system-ui" }}
                      >
                        Payment
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ borderTop: "1px solid #333", borderBottom : "none" }}>
                    <tr style={{ width: "100%", textAlign: "center" }}>
                      <td
                        style={{
                          borderRight: "1px solid #333",
                          borderBottom: "1px solid #333",
                          padding: "2px 5px",
                        }}
                      >
                        1
                      </td>
                      <td
                        style={{
                          borderRight: "1px solid #333",
                          borderBottom: "1px solid #333",
                          padding: "2px 5px",
                        }}
                      >
                        {data?.invoice_number || 0}
                      </td>
                      <td
                        style={{
                          borderRight: "1px solid #333",
                          borderBottom: "1px solid #333",
                          padding: "2px 5px",
                        }}
                      >
                        {receiptObj?.created_date ? moment(receiptObj.created_date).format("DD-MM-YYYY") : "-"}
                      </td>
                      <td
                        style={{
                          borderRight: "1px solid #333",
                          borderBottom: "1px solid #333",
                          padding: "2px 5px",
                        }}
                      >
                        {receiptObj?.amount || 0}
                      </td>
                    </tr>
                    <tr style={{ width: "100%" }}>
                      <td
                      colSpan={2}
                        style={{
                          borderRight: "1px solid #333",
                          borderBottom: "1px solid #333",
                        }}
                      ></td>
                      <td
                        style={{
                          borderRight: "1px solid #333",
                          borderBottom: "1px solid #333",
                          textAlign: "center",
                        }}
                      >
                        Total
                      </td>
                      <td
                        style={{
                          borderRight: "1px solid #333",
                          borderBottom: "1px solid #333",
                          textAlign: "center",
                        }}
                      >
                        {receiptObj?.amount || 0}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ height: "16px" }} />
                    </tr>

                    <tr style={{ width: "100%"}}>
                      <td
                        colSpan={9}
                        style={{
                          padding: "26px 3px 25px",
                          fontFamily: "system-ui",
                          fontSize: "14px",
                        }}
                      >
                        <strong>
                          In Words Received : UAE DIRHAMS{" "}
                          {(receiptObj?.amount &&
                            String(receiptObj.amount).split(".").length > 1 &&
                            numToWordsDhiram(
                              Number(String(receiptObj.amount).split(".")[0])
                            ) +
                              " AND " +
                              numToWordsDhiram(
                                Number(
                                  String(receiptObj.amount.toFixed(2)).split(".")[1]
                                )
                              ) +
                              " FILS ONLY") ||
                            numToWordsDhiram(
                              Number(String(receiptObj.amount).split(".")[0])
                            ) + " ONLY"}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
          <tbody style={{ border: "1px solid #000000", borderTop: "0px" }}>
            <tr>
              <td
                colSpan={9}
                style={{
                  padding: "8px 0 8px",
                  fontSize: "14px",
                  WebkitTextAlign: "center",
                  textAlign: "center",
                  // borderTop: "1px solid #000000",
                  marginTop: "-4px",
                  position: "relative",
                }}
              >
                ***This is a computer generated receipt and no signature is
                required***
                {/* <div
                  style={{
                    position: "absolute",
                    right: "7px",
                    top: "7px",
                  }}
                >
                  {invoiceItem?.updated_by
                            ? `*Updated by- ${invoiceItem.updated_by}*`
                            : invoiceItem?.created_by
                            ? `*Created by- ${invoiceItem.created_by}*`
                            : ""}
                </div> */}
              </td>
            </tr>
          </tbody>
        </table>
      </Container>
    );
  }
}

export default DownloadPayInvoice;
